var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseModule } from './../commons/BaseModule';
import uniqid from 'uniqid';
import Vue from 'vue';
import ModalConfirm from './components/ModalConfirm.vue';
var ModalsModule = (function (_super) {
    __extends(ModalsModule, _super);
    function ModalsModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.moduleContainerAddItemFunction = null;
        _this.moduleContainerRemoveItemFunction = null;
        return _this;
    }
    ModalsModule.prototype.preInstall = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            Vue.prototype.$addModal = _this.addModal.bind(_this);
            Vue.prototype.$addModalConfirm = _this.addModalConfirm.bind(_this);
            resolve(true);
        });
    };
    ModalsModule.prototype.finalizeInstall = function (options) {
        return new Promise(function (resolve, reject) {
            resolve(true);
        });
    };
    ModalsModule.prototype.registerModuleContainerAddItemFunction = function (f) {
        this.moduleContainerAddItemFunction = f;
    };
    ModalsModule.prototype.registerModuleContainerRemoveItemFunction = function (f) {
        this.moduleContainerRemoveItemFunction = f;
    };
    ModalsModule.prototype.addModal = function (item) {
        if (!this.moduleContainerAddItemFunction)
            return;
        if (!item.id)
            item.id = uniqid.time();
        this.moduleContainerAddItemFunction(item);
    };
    ModalsModule.prototype.addModalConfirm = function (props) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var item = {
                component: ModalConfirm,
                props: props,
                id: uniqid.time(),
                callback: function (isSuccess, data) {
                    resolve({ isSuccess: isSuccess, data: data });
                }
            };
            _this.addModal(item);
        });
    };
    return ModalsModule;
}(BaseModule));
export default ModalsModule;



//////////////////
// WEBPACK FOOTER
// ./src/modules/modals/index.ts
// module id = null
// module chunks = 